import React from "react";
import {OnboardingPage} from "../../routes/community/onboarding";

export default function OnboardingGate(props) {

    return <OnboardingPage onComplete={()=>{
        props?.updateParent();
    }} />
}